// eslint-disable-next-line import/prefer-default-export
export const UPDATE_BID_SELECTION_TEMPLATE = 'UPDATE_BID_SELECTION_TEMPLATE';
